import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  // Navigate back to home page
  const goToHomepage = () => {
    navigate('/');
  };

  // Styles
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: 'white',
      padding: '1rem',
    },
    oopsContainer: {
      position: 'relative',
      marginBottom: '1.5rem',
      textAlign: 'center',
    },
    oopsText: {
      fontSize: '6rem',
      fontWeight: 'bold',
      backgroundImage: 'linear-gradient(to right, #1e3a8a, #8b5cf6, #3730a3)',
      backgroundClip: 'text',
      color: 'transparent',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      '@media (min-width: 768px)': {
        fontSize: '9rem',
      }
    },
    starsOverlay: {
      position: 'absolute',
      inset: 0,
      opacity: 0.75,
      pointerEvents: 'none',
      overflow: 'hidden',
    },
    starsPattern: {
      position: 'absolute',
      inset: 0,
      background: 'radial-gradient(white, rgba(255,255,255,.2))',
      backgroundSize: '2px 2px',
    },
    errorHeading: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      color: 'white',
      letterSpacing: '0.05em',
      textAlign: 'center',
    },
    errorText: {
      fontSize: '1.125rem',
      marginBottom: '2.5rem',
      maxWidth: '28rem',
      textAlign: 'center',
      color: 'black',
    },
    button: {
      padding: '0.75rem 2rem',
      backgroundColor: '#2563eb',
      color: 'white',
      borderRadius: '9999px',
      fontWeight: '600',
      fontSize: '1.125rem',
      transition: 'all 0.2s ease',
      cursor: 'pointer',
      border: 'none',
      outline: 'none',
      width:'300px'
    },
    backgroundStars: {
      position: 'fixed',
      inset: 0,
      zIndex: -10,
      overflow: 'hidden',
      pointerEvents: 'none',
    },
    backgroundOverlay: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundColor: 'black',
      opacity: 0.9,
    },
    starryBackground: {
      position: 'absolute',
      inset: 0,
      opacity: 0.4,
      backgroundImage: 'radial-gradient(white 1px, transparent 1px)',
      backgroundSize: '50px 50px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.oopsContainer}>
        <h1 style={styles.oopsText}>
          Oops!
        </h1>
        <div style={styles.starsOverlay}>
          <div style={styles.starsPattern}></div>
        </div>
      </div>
      
      <h2 style={styles.errorHeading}>
        404 - PAGE NOT FOUND
      </h2>
      
      <p style={styles.errorText}>
        The page you are looking for might have been removed,
        had its name changed or is temporarily unavailable.
      </p>
      
      <button 
        onClick={goToHomepage}
        style={styles.button}
        onMouseOver={e => {
          e.target.style.backgroundColor = '#1d4ed8';
        }}
        onMouseOut={e => {
          e.target.style.backgroundColor = '#2563eb';
        }}
      >
        GO TO HOMEPAGE
      </button>
      
      <div style={styles.backgroundStars}>
        <div style={styles.backgroundOverlay} />
        <div style={styles.starryBackground} />
      </div>
    </div>
  );
};

export default NotFound;